import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { prescriptionsApi } from '../api/prescriptions.api';
import { CreatePrescriptionDto } from '../types/prescription.types';

export const usePrescription = (id: number) => {
  return useQuery({
    queryKey: ['prescriptions', id],
    queryFn: () => prescriptionsApi.getById(id),
    enabled: !!id,
  });
};

export const usePrescriptionsByVisitId = (visitId: number) => {
  return useQuery({
    queryKey: ['prescriptions', 'visit', visitId],
    queryFn: () => prescriptionsApi.getByVisitId(visitId),
    enabled: !!visitId,
  });
};

export const useCreatePrescription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePrescriptionDto) => prescriptionsApi.create(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['prescriptions'] });
      queryClient.invalidateQueries({ queryKey: ['prescriptions', 'visit', variables.visitId] });
    },
  });
};

